import { render, staticRenderFns } from "./rp-list.html?vue&type=template&id=b9de403c&scoped=true&"
import script from "./rp-list.js?vue&type=script&lang=js&"
export * from "./rp-list.js?vue&type=script&lang=js&"
import style0 from "./rp-list.scss?vue&type=style&index=0&id=b9de403c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9de403c",
  null
  
)

export default component.exports